<template>
  <div class="form addCard" v-loading="loading">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span
          ><h4>{{ config.title }}</h4></span
        >
      </div>
      <div>
        <el-form ref="form" label-width="70px" label-position="left">
          <el-form-item :label="config['setp1'].title">
            <div class="input">
              <div>
                <h3>{{ config["setp1"].text }}</h3>
              </div>
              <div>
                <el-button
                  type="primary"
                  @click="doDownload(config['setp1'].temUrl)"
                  >{{ config["setp1"].button }}</el-button
                >
              </div>
            </div>
          </el-form-item>
          <template v-if="config['setp2']">
            <el-form-item :label="config['setp2'].title">
              <div class="input">
                <div>
                  <h3>{{ config["setp2"].text }}</h3>
                </div>
                <div class="file">
                  <template v-if="config.type == 'ossPage'">
                    <cc-uploader
                      :config="uploaderConf"
                      fType="file"
                      v-model="productFilePath"
                      :fFormatV2="config.fileType[1]"
                    />
                  </template>
                  <template v-else>
                    <el-button>
                      <input
                        type="file"
                        class="input_file"
                        @change="file2Change"
                        v-if="showInput"
                      />
                      {{ language("batchAddCard.file") }}
                    </el-button>
                    {{ file2Name }}
                  </template>
                </div>
              </div>
            </el-form-item>
          </template>
          <template v-if="config['setp3']">
            <el-form-item :label="config['setp3'].title">
              <div class="input">
                <div>
                  <h3>{{ config["setp3"].text }}</h3>
                </div>
                <div>
                  <template v-if="config.type == 'ossPage'">
                    <cc-uploader
                      :config="uploaderConf"
                      fType="file"
                      v-model="imageFilePath"
                      :fFormatV2="config.fileType[2]"
                      :maxFSize="200"
                    />
                  </template>
                  <template v-else>
                    <el-button>
                      <input
                        type="file"
                        class="input_file"
                        @change="file3Change"
                        v-if="showInput"
                      />
                      {{ language("batchAddCard.file") }}
                    </el-button>
                    {{ file3Name }}
                  </template>
                </div>
              </div>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button type="primary" @click="uploader">{{
              config["stepButton"]
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('batchAddCard.tips')"
      :visible.sync="dialog"
      width="50%"
      append-to-body
    >
      <div v-for="(items, index) in err">
        <div class="title_tips" v-if="items.code != 200">
          {{ items.message }}
        </div>
        <div
          class="err_tips"
          v-if="items.code == 200"
          v-for="(item, index) in items.fieldValidResults"
        >
          <div>RowNum :{{ items.rowNum }}</div>
          <div>{{ item.message }}</div>
          <div>{{ item.fildName }}</div>
          <el-divider></el-divider>
        </div>
      </div>

      <div class="change_shop_button_wrap">
        <el-button type="primary" @click="dialog = false">{{
          language("batchAddCard.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uploadUtils from "../utils/ossUtils";
import axios from "axios";

export default {
  props: {
    config: Object,
    // add: {
    //   type: "input",  input  ossPage 二進制或oss路徑, other 是特殊
    //   fileType:{},//限制文件格式
    //    form:{shopNum:111,type:1 }, //默認參數
    //    request: "admin/merchant/inventory/uploadFile",// 請求地址
    //   title: this.language("productInventory.step1Title"),
    //   setp1: {
    //     title: this.language("productInventory.step") + "1",
    //     temUrl: "/admin/merchant/inventory/downloadTemplate", //模版下載地址
    //     text: this.language("productInventory.addStep1Text"),
    //     button: this.language("productInventory.download"),
    //   },
    //   setp2: {
    //     title: this.language("productInventory.step") + "2",
    //     text: this.language("productInventory.addStep2Text"),
    //   },
    //   stepButton: this.language("productInventory.stepButton"),
    // },
  },
  data() {
    return {
      uploaderConf: uploadUtils.configPublish,
      loading: false,
      file2: "",
      file2Name: "",
      file3Name: "",
      file3: "",
      productFilePath: "",
      imageFilePath: "",
      err: [],
      dialog: false,
      showInput: true,
    };
  },
  watch: {},
  methods: {
    doDownload(url) {
      // alert(url)
      console.log('url',url,this.config);
      //add/edit,的模版下载按钮多传mchShopNum参数
      if(url=='/admin/merchant/upload/downloadTemplateFile') url+= `?mchShopNum=${this.config.form.mchShopNum}`

      window.open(url);
      this.$message(this.language("common.downloading"));
    },
    file2Change(e) {
      let type = this.config.fileType[1];
      if (e.target.files[0].name.indexOf(type) > 0) {
        this.file2 = e.target.files[0];
        this.file2Name = e.target.files[0].name;
      } else {
        this.$message.error(this.language("batchAddCard.xlsxErrorTips"));
        return false;
      }
    },
    file3Change(e) {
      let type = this.config.fileType[2];
      if (e.target.files[0].name.indexOf(type) > 0) {
        this.file3 = e.target.files[0];
        this.file3Name = e.target.files[0].name;
      } else {
        this.$message.error(this.language("batchAddCard.xlsxErrorTips"));
        return false;
      }
    },
    uploader() {
      if (this.config.type == "other") {
        this.$confirm(
          this.language("batchAddCard.confirmText"),
          this.language("batchAddCard.tips"),
          {
            confirmButtonText: this.language("batchAddCard.confirm"),
            cancelButtonText: this.language("batchAddCard.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            this.uploaderDataV3();
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.config.type == "ossPage") {
        //oss文件形式
        this.uploaderDataV2();
      } else {
        //二進制
        this.uploaderData();
      }
    },

    uploaderData() {
      this.$confirm(
        this.language("batchAddCard.confirmText"),
        this.language("batchAddCard.tips"),
        {
          confirmButtonText: this.language("batchAddCard.confirm"),
          cancelButtonText: this.language("batchAddCard.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let formData = new FormData();
          formData.append("appId", "supnr");
          if (this.config.setp2 && this.config.setp2.formName) {
            formData.append(this.config.setp2.formName, this.file2);
          }
          if (this.config.setp3 && this.config.setp3.formName) {
            formData.append(this.config.setp3.formName, this.file3);
          }
          for (const key in this.config.form) {
            if (this.config.form[key]) {
              formData.append(key, this.config.form[key]);
            }
          }
          this.loading = true;
          axios({
            url: this.config.request,
            method: "POST",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then((res) => {
              this.loading = false;
              this.$message({
                message: this.language("batchAddCard.success"),
                type: "success",
              });
              this.file2 = "";
              this.file2Name = "";
              this.file3Name = "";
              this.file3 = "";
              this.$emit("success", true);
              this.refInput();
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(err.response.data.message);
              this.refInput();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    uploaderDataV2() {
      if (this.productFilePath == "") {
        this.$message.error(this.language("batchAddCard.productFilePathErr"));
        return false;
      }
      if (this.imageFilePath == "") {
        this.$message.error(this.language("batchAddCard.imageFilePathErr"));
        return false;
      }
      this.$confirm(
        this.language("batchAddCard.confirmText"),
        this.language("batchAddCard.tips"),
        {
          confirmButtonText: this.language("batchAddCard.confirm"),
          cancelButtonText: this.language("batchAddCard.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          let data = {
            productFilePath: this.productFilePath,
            imageFilePath: this.imageFilePath,
            opType: 0,
          };
          for (const key in this.config.form) {
            if (this.config.form[key]) {
              data[key] = this.config.form[key];
            }
          }
          //提交
          this.ccRequest
            .do(this.config.uploaderUrl, data)
            .then((res) => {
              this.loading = false;
              this.productFilePath = "";
              this.imageFilePath = "";
              if (res.code == 500) {
                this.dialog = true;
                this.err = res.data.validResultList;
                this.$message.error(this.language("batchAddCard.error"));
              } else {
                this.$emit("success", true);
                this.$message({
                  message: this.language("batchAddCard.success"),
                  type: "success",
                });
              }
              this.refInput();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err.response.data.message);
              this.refInput();
            });
        })
        .catch(() => {});
    },

    //先false 返回提醒信息然后再true 确认上传
    uploaderDataV3() {
      let formData = new FormData();
      formData.append("appId", "supnr");
      formData.append("confirm", false);
      if (this.config.setp2 && this.config.setp2.formName) {
        formData.append(this.config.setp2.formName, this.file2);
      }
      if (this.config.setp3 && this.config.setp3.formName) {
        formData.append(this.config.setp3.formName, this.file3);
      }
      for (const key in this.config.form) {
        if (this.config.form[key]) {
          formData.append(key, this.config.form[key]);
        }
      }
      this.loading = true;
      axios({
        url: this.config.request,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          console.log(res,'res')
          this.loading = false;
          if (res.data.data &&res.data.data.needConfirm) {
            this.$confirm(
              res.data.data.message,
              this.language("batchAddCard.tips"),
              {
                confirmButtonText: this.language("batchAddCard.upload"),
                cancelButtonText: this.language("batchAddCard.cancel"),
                type: "warning",
              }
            )
              .then(() => {
                this.uploaderDataV4();
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.$message({
              message: this.language("batchAddCard.success"),
              type: "success",
            });
            this.file2 = "";
            this.file2Name = "";
            this.file3Name = "";
            this.file3 = "";
            this.refInput();
            this.$emit("success", res);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(
            err.response.data.message,
            this.language("batchAddCard.tips"),
            {
              confirmButtonText: this.language("batchAddCard.cancel"),
              callback: (action) => {
                this.file2 = "";
                this.file2Name = "";
                this.file3Name = "";
                this.file3 = "";
                this.refInput();
              },
            }
          );
        });
    },
    uploaderDataV4() {
      let formData = new FormData();
      formData.append("appId", "supnr");
      formData.append("confirm", true);
      if (this.config.setp2 && this.config.setp2.formName) {
        formData.append(this.config.setp2.formName, this.file2);
      }
      if (this.config.setp3 && this.config.setp3.formName) {
        formData.append(this.config.setp3.formName, this.file3);
      }
      for (const key in this.config.form) {
        if (this.config.form[key]) {
          formData.append(key, this.config.form[key]);
        }
      }
      this.loading = true;
      axios({
        url: this.config.request,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          this.loading = false;
          this.$message({
            message: this.language("batchAddCard.success"),
            type: "success",
          });
          this.file2 = "";
          this.file2Name = "";
          this.file3Name = "";
          this.file3 = "";
          this.refInput();
          this.$emit("success", true);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.response.data.message);
          this.refInput();
        });
    },
    //重置 文件选择
    refInput() {
      this.showInput = false;
      setTimeout(() => {
        this.showInput = true;
      }, 100);
    },
  },
  mounted() {
    this.uploaderConf = uploadUtils.configPublishV2("/perm/sisProduct/");
  },
};
</script>
<style scoped>
.file {
  position: relative;
}
.input_file {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  opacity: 0;
  height: 40px;
  width: 98px;
  /* opacity: 1;
  height: 40px;
  width: 200px; */
}
.err_tips div {
  margin-top: 10px;
  font-size: 20px;
}
.title_tips {
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.addCard {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>